import t from"react";var e=function(e){var a=e.className,r=e.children,i=e.testid;return t.createElement("div",{className:a,"data-testid":i},r)};e.displayName="CustomAction";export{e as CustomAction};
//# sourceMappingURL=CustomAction.js.map
